import { ArrowLeft } from "lucide-react";

import CustomButton from "@/components/desktop/button/CustomButton.jsx";

const ProductBulkFooter = ({ uploadType, previewData, isLoading, isLoadingAttach, isProcessing, isIndividualFormValid, onBack, onSave, onClose }) => {
	const shouldShowSaveActions = ["individual", "bulk"].includes(uploadType) && previewData;
	const isSaveDisabled = isLoading || isLoadingAttach || isProcessing || !isIndividualFormValid;

	if (shouldShowSaveActions) {
		return (
			<>
				<CustomButton variant="secondary" onClick={onBack}>
					<ArrowLeft size={15} /> Volver
				</CustomButton>
				<CustomButton variant="success" onClick={onSave} disabled={isSaveDisabled}>
					{isProcessing ? "Cargando..." : "Guardar Productos"}
				</CustomButton>
			</>
		);
	}

	return (
		<CustomButton variant="secondary" onClick={onClose}>
			Cerrar
		</CustomButton>
	);
};

export default ProductBulkFooter;
